import React from 'react'
import { Button, CircularProgress } from '@material-ui/core'
import { ArrowRightIcon } from '~/assets/icons'

type LoginSubmitButtonProps = {
  title: string,
  loading: boolean,
  disabled?: boolean
}

export const LoginSubmitButton: React.FC<LoginSubmitButtonProps> = ({ title, loading, disabled }) => {
  return (
    <Button
      variant='contained'
      type='submit'
      color='primary'
      size='large'
      disabled={disabled || loading}
      endIcon={loading ? <CircularProgress size={20} color='inherit' /> : <ArrowRightIcon htmlColor='inherit' />}
      sx={{
        marginTop: 3,
        height: 56,
        width: '100%',
        fontWeight: 700
      }}
    >
      {title}
    </Button>
  )
}
